import { render, staticRenderFns } from "./TiketDetail.vue?vue&type=template&id=4d4670a0&scoped=true&"
import script from "./TiketDetail.vue?vue&type=script&lang=js&"
export * from "./TiketDetail.vue?vue&type=script&lang=js&"
import style0 from "./TiketDetail.vue?vue&type=style&index=0&id=4d4670a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4670a0",
  null
  
)

export default component.exports